export const openLinkInNewTab = (path: string): Window => {
  const TAB_OPTION: string = '_blank'
  return window.open(path, TAB_OPTION)
}
